exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._7adDBb7oOqwJ-dK27C25u{font-size:14px;font-weight:400;font-weight:600;color:\"[theme:neutralPrimary, default:#333333]\"}._7adDBb7oOqwJ-dK27C25u._2n-DH0iMGadfS9JhAKu5Ic{text-decoration:line-through}._8pmx2os3EYEVG-IDTO8M0{height:14px;width:14px;min-width:14px}html[dir=ltr] ._8pmx2os3EYEVG-IDTO8M0{margin-right:4px}html[dir=rtl] ._8pmx2os3EYEVG-IDTO8M0{margin-left:4px}.Z_KcFZ3ZI6oiYglRAEoyg{font-size:12px;font-weight:400;color:\"[theme:neutralSecondary, default:#666666]\"}._2a9_RIvzRfgZyzEhuEJDDK{font-size:12px;font-weight:400;color:\"[theme:neutralPrimary, default:#333333]\"}", ""]);

// exports
exports.locals = {
	"subject": "_7adDBb7oOqwJ-dK27C25u",
	"isCancelled": "_2n-DH0iMGadfS9JhAKu5Ic",
	"charm": "_8pmx2os3EYEVG-IDTO8M0",
	"timeSecondaryText": "Z_KcFZ3ZI6oiYglRAEoyg",
	"timePrimaryText": "_2a9_RIvzRfgZyzEhuEJDDK"
};